import { createApiClient } from '../apiClient';

const apiClient = createApiClient({
  baseURL: '/api/',
});

const login = () => apiClient
  .get('visitor-kiosk/login');

const fetchByAuthCredentials = () => apiClient
  .get('visitor-kiosk')
  .then(response => response.data);

const createPermit = data => apiClient
  .post('kiosk-permits', data)
  .then(response => response.data);

const checkOngoingSessions = (productId, licensePlate) => apiClient
  .post(`kiosk-products/${encodeURIComponent(productId)}/ongoing-session-checks`, { licensePlate })
  .then(response => response.data);

const checkUnlockCodeAvailability = (productId, unlockCode) => apiClient
  .post(`kiosk-products/${encodeURIComponent(productId)}/unlock-code-checks`, { unlockCode })
  .then(response => response.data);

export default {
  login,
  fetchByAuthCredentials,
  createPermit,
  checkOngoingSessions,
  checkUnlockCodeAvailability,
};
